import React from 'react';
import './legend.scss';
import RowLegend from './RowLegend';

export type LegendProps = {
  data: { name: string }[];
  totalImpact: number;
  impactUnit?: string | null;
};

export function Legend({ data, totalImpact, impactUnit }: LegendProps) {
  return (
    <div>
      {data.map((columnStacked) => (
        <RowLegend
          row={columnStacked}
          totalImpact={totalImpact}
          impactUnit={impactUnit ?? undefined}
        />
      ))}
    </div>
  );
}
